import Router from 'next/router'

/**
 * Removes all searches and filters from the URL
 */

interface ClearUrlParamsProps {
  baseUrl?: string
  keepParams?: string[]
}

const clearUrlParams = ({ baseUrl = document.location.href, keepParams = [] }: ClearUrlParamsProps = {}) => {
  // Create a URL object
  const url = new URL(baseUrl, document.location.origin)

  // Get the search parameters
  const params = url.searchParams

  // Iterate over all search parameters
  for (const key of params.keys()) {
    if (!keepParams.includes(key)) {
      // Remove parameter if it's not in keepParams
      params.delete(key)
    }
  }

  // Construct the new URL
  const newUrl = `${url.origin}${url.pathname}${params.toString() ? '?' + params.toString() : ''}`

  // Navigate to the new URL
  Router.push(newUrl)
}

export default clearUrlParams
